import "../../style/scss/App.scss";
import { DateTime } from "luxon";
import { BsCurrencyDollar } from "react-icons/bs";
import { GrDocumentMissing } from "react-icons/gr";

export default function EmploymentListItem({ employment, employers, onEdit }) {
  if (!employment) return <p>No employer configured</p>;
  const employerID = employment.ClientID || employment.IntermediaryID || employment.EmployerID;
  const employer = (employers || []).find((e) => e.ID === employerID);
  const startDate = DateTime.fromISO(employment?.StartDate).toFormat("MM/yyyy");
  const endDate = employment.EndDate ? DateTime.fromISO(employment?.EndDate).toFormat("MM/yyyy") : "now";
  const id = employment.ID || employment.id;
  const skills = employment.Skills || employment.skills || [];

  return (
    <li key={id}>
      <button
        type="button"
        className="centered skillLink employment-list-item"
        data-testid={`employment-edit-${id}`}
        onClick={() => onEdit?.(id)}
      >
        <div className="Job mobilePanel">
          <span className="title tooltip">{employment.Title || ""}</span>
          <span className="rightIcons">
            {employment.PayRate === 0 ? (
              <BsCurrencyDollar size={1} title="Missing pay rate" />
            ) : (
              ""
            )}
            {skills.length === 0 ? (
              <GrDocumentMissing size={1} title="Missing skills" />
            ) : (
              ""
            )}
            <span />
          </span>
          <span className="byline">{employer?.ShortName || employer?.Name || ""}</span>
          <span className="rightText">
            {startDate}&nbsp;-&nbsp;{endDate}
          </span>
        </div>
      </button>
    </li>
  );
}
